(function () {
  var desktopQuery = window.matchMedia("(min-width: 900px)");

  function pickSource(video) {
    var sources = Array.prototype.slice.call(
      video.querySelectorAll("source[data-src]"),
    );
    if (!sources.length) return null;

    var ranked = sources
      .map(function (source) {
        return {
          el: source,
          height: parseInt(source.getAttribute("data-height") || "0", 10) || 0,
        };
      })
      .sort(function (a, b) {
        return a.height - b.height;
      });

    var knownHeight = ranked.some(function (item) {
      return item.height > 0;
    });
    if (!knownHeight) {
      var mid = sources.filter(function (source) {
        return /720/.test(source.getAttribute("data-src") || "");
      })[0];
      if (mid) return mid;
      var notFullHd = sources.filter(function (source) {
        return !/1080/.test(source.getAttribute("data-src") || "");
      })[0];
      return notFullHd || sources[0];
    }

    var chosen = ranked[ranked.length - 1];
    for (var i = 0; i < ranked.length; i++) {
      if (ranked[i].height >= 720) {
        chosen = ranked[i];
        break;
      }
    }
    return chosen.el;
  }

  function activate(video) {
    if (video.getAttribute("data-gh-ready") === "1") {
      if (video.autoplay) video.play().catch(function () {});
      return;
    }

    var source = pickSource(video);
    if (!source) return;

    var playable = document.createElement("source");
    playable.src = source.getAttribute("data-src");
    playable.type = source.getAttribute("type") || "video/mp4";
    video.appendChild(playable);
    video.setAttribute("data-gh-ready", "1");
    video.load();
    if (video.autoplay) video.play().catch(function () {});
  }

  function run() {
    var desktop = desktopQuery.matches;
    document.querySelectorAll("video[data-gh-variant]").forEach(function (video) {
      var variant = video.getAttribute("data-gh-variant");
      var visible =
        variant === "all" ||
        (desktop && variant === "desktop") ||
        (!desktop && variant === "mobile");
      if (visible) activate(video);
      else video.pause();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }

  if (desktopQuery.addEventListener) {
    desktopQuery.addEventListener("change", run);
  } else if (desktopQuery.addListener) {
    desktopQuery.addListener(run);
  }
})();
